'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getAlignmentValue = function getAlignmentValue(index, lenChildren) {
  if (index === 0) return 'left';else if (index < lenChildren - 1) return 'center';
  return 'right';
};

var GridFooter = function (_React$Component) {
  _inherits(GridFooter, _React$Component);

  function GridFooter() {
    _classCallCheck(this, GridFooter);

    return _possibleConstructorReturn(this, (GridFooter.__proto__ || Object.getPrototypeOf(GridFooter)).apply(this, arguments));
  }

  _createClass(GridFooter, [{
    key: 'getMobileOrder',
    value: function getMobileOrder() {
      return this.props.mobileOrder.length > 0 ? this.props.mobileOrder : Array(this.props.children.length).fill(0).map(function (el, index) {
        return index;
      });
    }
  }, {
    key: 'orderChildren',
    value: function orderChildren() {
      var _props = this.props,
          children = _props.children,
          width = _props.width;

      return width > 768 ? children : this.getMobileOrder().map(function (el) {
        return children[el];
      });
    }
  }, {
    key: 'createGridColumn',
    value: function createGridColumn(child, index) {
      var _props2 = this.props,
          fixToSides = _props2.fixToSides,
          children = _props2.children,
          width = _props2.width;

      var textAlign = fixToSides && width > 768 ? getAlignmentValue(index, children.length) : 'center';
      return _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { textAlign: textAlign, key: index + '_footer' },
        child
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          children = _props3.children,
          gridParams = _props3.gridParams,
          className = _props3.className;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        _extends({
          columns: children.length
        }, gridParams, {
          className: className
        }),
        this.orderChildren().map(function (child, index) {
          return _this2.createGridColumn(child, index);
        })
      );
    }
  }]);

  return GridFooter;
}(_react2.default.Component);

exports.default = GridFooter;


GridFooter.propTypes = {
  gridParams: _propTypes2.default.shape({
    divided: _propTypes2.default.bool,
    doubling: _propTypes2.default.bool,
    inverted: _propTypes2.default.bool,
    padded: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
    stackable: _propTypes2.default.bool,
    stretched: _propTypes2.default.bool,
    textAlign: _propTypes2.default.oneOf(['left', 'center', 'right', 'justified']),
    verticalAlign: _propTypes2.default.oneOf(['bottom', 'middle', 'top'])

  }),
  mobileOrder: _propTypes2.default.arrayOf(_propTypes2.default.number),
  width: _propTypes2.default.number.isRequired,
  fixToSides: _propTypes2.default.bool,
  className: _propTypes2.default.string
};

GridFooter.defaultProps = {
  mobileOrder: [],
  gridParams: {},
  fixToSides: true,
  className: ''
};


//////////////////
// WEBPACK FOOTER
// ./~/@fishrmn/fishrmn-components/build/components/organisms/GridFooter/GridFooter.js
// module id = 510
// module chunks = 168707334958949